import { Sale } from '@/types';

/**
 * Shape used in the tab close flow for selected payment methods.
 * Shared between store and components to avoid inline type duplication.
 */
export interface SelectedPaymentMethodEntry {
  methodId: string;
  amount: number;
  defaultPaymentMethodId?: number;
}

export type TabViewMode = 'list' | 'tables';
export type CategoryTabsMode = 'open' | 'credit';

export interface TabsUIState {
  selectedTabId: string | null;
  viewMode: TabViewMode;
  categoryTabsMode: CategoryTabsMode;
  isTablesLocked: boolean;
  isNewTabOpen: boolean;
  isProductCatalogOpen: boolean;
  isTableModalOpen: boolean;
  isTabDetailsModalOpen: boolean;
  isCloseTabOpen: boolean;
  isSplitTabOpen: boolean;
  selectedPaymentMethods: SelectedPaymentMethodEntry[];
  newCustomerName: string;
  newCustomerDiscount: number;
  discountInput: string;
  itemDiscountInputs: Record<string, string>;
  pendingAssignTableId: string | null;
  pendingSaleForInvoice: Sale | null;
  currentRoomId: string | null;
}

export interface TabsUIActions {
  setSelectedTabId: (id: string | null) => void;
  setViewMode: (mode: TabViewMode) => void;
  setCategoryTabsMode: (mode: CategoryTabsMode) => void;
  setIsTablesLocked: (locked: boolean) => void;
  setIsNewTabOpen: (open: boolean) => void;
  setIsProductCatalogOpen: (open: boolean) => void;
  setIsTableModalOpen: (open: boolean) => void;
  setIsTabDetailsModalOpen: (open: boolean) => void;
  setIsCloseTabOpen: (open: boolean) => void;
  setIsSplitTabOpen: (open: boolean) => void;
  setSelectedPaymentMethods: (methods: SelectedPaymentMethodEntry[]) => void;
  setNewCustomerName: (name: string) => void;
  setNewCustomerDiscount: (discount: number) => void;
  setDiscountInput: (value: string) => void;
  setItemDiscountInputs: (value: Record<string, string> | ((prev: Record<string, string>) => Record<string, string>)) => void;
  setPendingAssignTableId: (id: string | null) => void;
  setPendingSaleForInvoice: (sale: Sale | null) => void;
  setCurrentRoomId: (roomId: string | null) => void;
  closeTabSelection: () => void;
  clearPendingSaleForInvoice: () => void;
  resetTabsUIState: () => void;
}

export type TabsUIStore = TabsUIState & TabsUIActions;

export const TABS_UI_INITIAL_STATE: TabsUIState = {
  selectedTabId: null,
  viewMode: 'list',
  categoryTabsMode: 'open',
  isTablesLocked: true,
  isNewTabOpen: false,
  isProductCatalogOpen: false,
  isTableModalOpen: false,
  isTabDetailsModalOpen: false,
  isCloseTabOpen: false,
  isSplitTabOpen: false,
  selectedPaymentMethods: [],
  newCustomerName: '',
  newCustomerDiscount: 0,
  discountInput: '',
  itemDiscountInputs: {},
  pendingAssignTableId: null,
  pendingSaleForInvoice: null,
  currentRoomId: null,
};
